module.exports = __webpack_public_path__ + "2acb60f2/img/share-action-icon.9c12578c.svg";